import React from "react";
import { Redirect } from "react-router-dom";



// Authentication related pages
// import Login from "../components/Authentication/login";
import Logout from "../components/Authentication/Logout";
// import Register from "../pages/Authentication/Register";
import ForgetPwd from "../components/Authentication/ForgetPassword";
import ResetPwd from "../components/Authentication/resetPwd";

import Dashboard from "../components/dashboard/index";
import Screens from "../components/screens/index";
import DetailedScreen from "../components/screens/screen_dtails";
import Contents from "../components/contents/index";
import Campaigns from "../components/campaigns/index";
import Settings from "../components/settings/index";
import Setup from "../components/setup/index";
import AddDevice from "../components/setup/addDevice";
import SavedCampaigns from "../components/savedCampaigns/index";
import UserManager from "../components/admin/manage_users";
import Report from "../components/report/index";
import PageNoteFound from "../components/Common/pages-404";

const role = localStorage.getItem("authUser") ? JSON.parse(localStorage.getItem("authUser")).data.role : ""

const userRoutes = [
    // this route should be at the end of all other routes
    { path: "/dashboard", component: role !== "admin" ? Dashboard : PageNoteFound},
    { path: "/screens/:player_id", component: role !== "admin" ? DetailedScreen : PageNoteFound},
    { path: "/screens", component: role !== "admin" ? Screens : PageNoteFound},
    { path: "/contents", component: role !== "admin" ? Contents: PageNoteFound},
    { path: "/campaigns", component: role !== "admin" ? Campaigns: PageNoteFound},
    { path: "/settings", component: Settings},
    { path: "/setup", component: role !== "admin" ? Setup: PageNoteFound},
    { path: "/add_device/:code", component: role !== "admin" ? AddDevice: PageNoteFound},
    { path: "/saved_campaigns", component: role !== "admin" ? SavedCampaigns : PageNoteFound},
    { path: "/manage_users", exact: true, component: role === "admin" ? UserManager : PageNoteFound},
    { path: "/report", component: role !== "admin" ? Report : PageNoteFound },
    { path: "/", exact: true, component: () => {
            if(role !== "admin") {
                return <Redirect to="/dashboard" />
            } else {
                return <Redirect to="/manage_users" />
            }
        }
    }
];

const authRoutes = [
    { path: "/logout", component: Logout },
    { path: "/forgot-password", component: ForgetPwd },
    // { path: "/reset-password", component: ResetPwd },
    // { path: "/register", component: Register }
];

export { userRoutes, authRoutes };
